import React, { useEffect, useState } from 'react';
import { FileUpload } from '@/baseComponents';
import './index.less';

const CertAttachmentAttachment = ({
  value,
  onChange,
  isIDCard = true
}) => {
  const [list, setList] = useState([]);

  const handleOnChange = (imgSrc, index) => {
    const nList = [...list];
    nList[index] = imgSrc;
    setList(nList);
    onChange(nList);
  };

  useEffect(() => {
    if (value) {
      setList(value);
    }
  }, [value]);
  return /*#__PURE__*/React.createElement("div", {
    className: "cert-attachment-upload"
  }, isIDCard && /*#__PURE__*/React.createElement("div", {
    className: "img-upload-item"
  }, /*#__PURE__*/React.createElement(FileUpload, {
    value: list[0],
    onChange: val => {
      handleOnChange(val, 0);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "uplaod-btn-con bg-card-front"
  }, list[0] && /*#__PURE__*/React.createElement("img", {
    className: "img-previe",
    src: list[0],
    alt: "233"
  })))), isIDCard && /*#__PURE__*/React.createElement("div", {
    className: "img-upload-item "
  }, /*#__PURE__*/React.createElement(FileUpload, {
    value: list[1],
    onChange: val => {
      handleOnChange(val, 1);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "uplaod-btn-con bg-card-back"
  }, list[1] && /*#__PURE__*/React.createElement("img", {
    className: "img-previe",
    src: list[1],
    alt: "233"
  })))), !isIDCard && /*#__PURE__*/React.createElement("div", {
    className: "img-upload-item bg-card"
  }, /*#__PURE__*/React.createElement(FileUpload, {
    onChange: val => {
      handleOnChange(val, 0);
    },
    value: list[0]
  }, /*#__PURE__*/React.createElement("div", {
    className: "uplaod-btn-con bg-card"
  }, list[0] && /*#__PURE__*/React.createElement("img", {
    className: "img-previe",
    src: list[0],
    alt: "233"
  })))));
};

export default CertAttachmentAttachment;